import { Funcionalidade } from './funcionalidade.model';
import { TreeNode } from './ng-tree-table/model';

export class No implements TreeNode {
    label: string;
    data: any;
    icon: any;
    expandedIcon: any;
    collapsedIcon: any;
    children: No[] = [];
    leaf: boolean;
    expanded: boolean;
    type: string;
    parent: No;
    partialSelected: boolean;
    styleClass: string;
    draggable: boolean;
    droppable: boolean;
    selectable: boolean;
    selected: boolean;


    constructor(label, data, expanded?:boolean) {
        this.label = label;
        this.data = data;
        this.expanded = expanded;
    }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/arvore-acesso/no.model.ts